var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBlue26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6204 31.0913C34.5246 36.1171 29.6106 36.998 28.0048 36.998C27.5332 36.998 20.1896 37.3874 9.63307 27.3714C1.13748 19.3107 0.0994255 10.6427 0.00898121 8.99579C-0.0789964 7.39163 0.380214 3.36747 5.91458 0.377517C6.60031 0.00701103 7.95986 -0.157064 8.31094 0.194114C8.46675 0.349965 13.1119 7.99571 13.234 8.24902C13.3561 8.50192 13.4173 8.75111 13.4173 8.99538C13.4173 9.3445 13.1686 9.78121 12.6708 10.3051C12.1733 10.829 11.6323 11.3093 11.0473 11.7456C10.4623 12.1823 9.92126 12.6449 9.42341 13.1339C8.92597 13.6224 8.67724 14.0246 8.67724 14.3387C8.71095 15.1542 9.37901 18.075 14.4681 22.5478C19.5581 27.0219 22.01 28.2822 22.2455 28.3694C22.4815 28.4566 22.6776 28.4998 22.8347 28.4998C23.1492 28.4998 23.5508 28.2514 24.0396 27.7538C24.528 27.2558 26.1712 25.0032 26.695 24.5052C27.2187 24.0081 27.6553 23.7593 28.0048 23.7593C28.249 23.7593 28.4977 23.8201 28.7505 23.9423C29.0038 24.0644 36.6574 28.5442 36.8038 28.6939C37.2009 29.101 36.9205 30.3716 36.6204 31.0913Z",
    fill: "#002277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBlue26);
export default __webpack_public_path__ + "static/media/phone-blue-26.c563e249eb759965e9f4bafe2cff05fd.svg";
export { ForwardRef as ReactComponent };